import { z } from "zod";

export const generalAddendumSchema = z.object({
  addendum: z.string().min(1, "This is a required field."),
});

export type GeneralAddendumFormValues = z.infer<typeof generalAddendumSchema>;
